const WIDTH = 270

export const DEVELOPER_MODE = {
  REFERENCE_FIELD: { width: WIDTH, height: 446 },
  DEFAULT: { width: WIDTH, height: 353 },
}
export const DATA_MODE = {
  REFERENCE_FIELD: { width: WIDTH, height: 354 },
  DEFAULT: { width: WIDTH, height: 259 },
}
